import { Container, Spinner, Text, Flex } from '@grupoboticario/flora-react';

export function Loading() {
  return (
    <Flex align="center" justify="center">
      <Container
        css={{
          padding: '3rem 6rem',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Spinner
          color="$9"
          emptyColor="$shadowLight"
          size="md"
          speed="800ms"
          thickness="3px"
        />
        <Text
          css={{
            fontSize: '20px',
            lineHeight: 'normal',
            marginTop: '12px',
          }}
        >
          Carregando informações
        </Text>
      </Container>
    </Flex>
  );
}
